import { useCallback } from 'react'

import { useIsUnmounted, useNotification } from '@/hooks'
import { enableUser } from '@/features/domain/user/actions'
import { useAppDispatch } from '@/store'

import { useController } from '../../../hooks/useController'
import { useTexts } from './useTexts'

export function useOnSubmit() {
  const {
    update,
    close,
    data: { userId },
  } = useController()

  const texts = useTexts()
  const toast = useNotification()
  const dispatch = useAppDispatch()
  const isUnmounted = useIsUnmounted()

  return useCallback(async () => {
    update({ status: 'submitting' })

    // if the component has been unmounted during the async operation stop here
    if (isUnmounted()) return

    try {
      const thunkResult = await dispatch(enableUser({ userId, enabled: false }))

      if (!enableUser.fulfilled.match(thunkResult)) {
        throw new Error(thunkResult.payload?.message ?? 'Internal error')
      }

      toast.success(texts.disableUserSuccess, { autoClose: 5000 })
      update({ status: 'ready' })
    } catch (error) {
      toast.error(texts.disableUserError, { autoClose: 5000 })
      update({ status: 'ready' })
    } finally {
      close?.()
    }
  }, [toast, texts, dispatch, isUnmounted, close, update, userId])
}
